import { LocationDescriptorObject } from 'history';
import { UiRoutes } from '../lib/constants';

const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLoginPath';

const AUTH_ROUTES = [UiRoutes.LOGIN, UiRoutes.ADMIN_LOGIN, UiRoutes.LOGIN_OTP];

type RedirectLocation = {
  pathname?: string;
  search?: string;
  hash?: string;
  state?: {
    redirectAfterLoginPath?: string;
  };
};

const getPathFromLocation = (location?: RedirectLocation): string => {
  const pathname = location?.pathname || '';
  const search = location?.search || '';
  const hash = location?.hash || '';

  return `${pathname}${search}${hash}`;
};

export const isValidRedirectAfterLoginPath = (path?: string | null): path is string => {
  if (!path || !path.startsWith('/') || path.startsWith('//')) return false;

  const pathname = path.split(/[?#]/)[0];
  return !AUTH_ROUTES.includes(pathname);
};

export const getRedirectAfterLoginPath = (
  location?: RedirectLocation
): string | null => {
  const stateRedirectPath = location?.state?.redirectAfterLoginPath;
  if (isValidRedirectAfterLoginPath(stateRedirectPath)) return stateRedirectPath;

  const storedRedirectPath = window.sessionStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
  return isValidRedirectAfterLoginPath(storedRedirectPath) ? storedRedirectPath : null;
};

export const clearRedirectAfterLoginPath = (): void => {
  window.sessionStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
};

export const getLoginRedirectLocation = (
  location?: RedirectLocation
): LocationDescriptorObject => {
  const redirectAfterLoginPath = getPathFromLocation(location);

  if (isValidRedirectAfterLoginPath(redirectAfterLoginPath)) {
    window.sessionStorage.setItem(
      REDIRECT_AFTER_LOGIN_KEY,
      redirectAfterLoginPath
    );
  }

  return {
    pathname: UiRoutes.LOGIN,
    state: {
      redirectAfterLoginPath,
    },
  };
};
